<div class="modal-component">
    <div class="modal-header-content">
        <div class="header-text-container">
            <div class="header-text">
                Wichtige Patientennotizen
            </div>
        </div>
        <button class="modal-close-button" type="button" (click)="onClose()">
            <i class="fa-solid fa-times icon-center"></i>
        </button>
    </div>
    <div class="modal-body-container">
       <mat-tab-group>
           @for (note of data.notes; track note; let index = $index) {
               <mat-tab [label]="'Notiz #' + (index + 1)">
                   <div class="p-6 bg-app-background-20 rounded-lg mt-4">
                       <h1 class="text-lg text-app-primary-20">{{note.note}}</h1>
                   </div>
               </mat-tab>
           }
       </mat-tab-group>
    </div>
    <div class="modal-button-container">
    </div>
</div>
